export const isEscapeKey = event => {
  const e = event || window.event;
  if ('key' in e) {
    return e.key === 'Escape' || e.key === 'Esc';
  }
  return e.keyCode === 27;
};
